module.exports = __webpack_public_path__ + "teqbahn-assets/media/speakupLogo.03c5c15a.png";